module.exports = __webpack_public_path__ + "img/993.1890c770.png";